import { Flex, Show } from "@chakra-ui/react";
import UTMLink from "@components/UTMLink";
import React from "react";

import { trackEvent } from "../../utils";
import { DASHBOARD_BANNER_CLICK } from "@constants/analytics";
import BaseImage from "@components/BaseImage";

const DashboardBanner = () => {
  return (
    <UTMLink
      href="/gain"
      isExternal
      onClick={() =>
        trackEvent(DASHBOARD_BANNER_CLICK, { redirectLink: "/gain" })
      }
    >
      <Flex
        overflow="hidden"
        w={{ base: "100%", md: "748px" }}
        borderRadius="8px"
        position="relative"
      >
        <Show above="md">
          <BaseImage
            key="dasboard_banner"
            src="/assets/dashboard/banner.png"
            alt="image banner"
            width={872}
            height={154}
            layout="responsive"
          />
        </Show>
        <Show below="md">
          <BaseImage
            key="dasboard_banner"
            src="/assets/dashboard/banner_mobile.png"
            alt="image banner"
            width={984}
            height={366}
            layout="responsive"
          />
        </Show>
      </Flex>
    </UTMLink>
  );
};

export default DashboardBanner;
